<template>
<div class="chapter">
<div class="inner_page">
<p class="P_WFP_ChapHead" id="auto_bookmark_table_of_contents_1"><span>Dedication</span></p>
<p class="P_WFP_BodyText">This book is for the next generation of future scientists, engineers, astronauts, explorers, and innovators—humanity’s real Star Challengers.</p>
<p class="P_Normal"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0006.vue?352df974